import React from 'react';
import { FAQS } from '../mock';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from './ui/accordion';

const FAQ = () => (
  <section className="section" id="faq" data-testid="faq-section">
    <div className="container">
      <div className="section-title">
        <div className="eyebrow">FAQ</div>
        <h2>Questions, answered.</h2>
        <p>Everything you want to know about personalized, compatibility-based matchmaking at Krysha.</p>
      </div>
      <div className="faq-wrap">
        <Accordion type="single" collapsible>
          {FAQS.map((f, i) => (
            <AccordionItem value={`faq-${i}`} key={f.q} className="faq-item">
              <AccordionTrigger className="faq-q" data-testid={`faq-question-${i}`}>{f.q}</AccordionTrigger>
              <AccordionContent className="faq-a">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  </section>
);

export default FAQ;
